import React from 'react';
import { useEffect } from 'react';
import { supabase } from '../supabase';
import { useState } from 'react';
import { useRef } from 'react';
import pic42 from '../assets/pic42.png'
import './sec1-p3.css'

const Sec1booking = ({ loading}) => {
    const [headers, setheaders]= useState([]);




 const secRef = useRef(null);


useEffect(() => {
  if (loading) return;

  const el = secRef.current;
  if (!el) return;

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        el.classList.remove("in-view");
        void el.offsetHeight;
        el.classList.add("in-view");
      } else {
        el.classList.remove("in-view");
      }
    },
    { threshold: 0.3 }
  );

  observer.observe(el);

  return () => observer.disconnect();

}, [loading]);






useEffect(() => {
const getheaders = async()=>{
    const res = await supabase.from('static_content').select('*').order('id', { ascending: true });;
console.log(res.data);
console.log(res.data[0]?.title_ar);
setheaders(res.data);
}
getheaders();
}, []);



    return ( 
        <section className='sec1-containerp2' ref={secRef} >
             <article className='sec1-sub-containerp3'>
                                <h1 className='header-herop2'>{headers?.[10]?.header}</h1>
                                <img className='img-sec1-p3' src={pic42} alt='ticket decorative-image' ></img>
            </article>





        </section>
     );
}
 
export default Sec1booking;